export default __webpack_public_path__ + "static/media/ep1collage1.d57c4102.jpg";